import { Injectable } from "@angular/core";
import { OrdersTableDefinitionFactory } from "../../model/OrdersTableDefinitionFactory";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BaseBlotterDataAdapter } from "./BaseBlotterDataAdapter";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class RawDataOrderAdapter extends BaseBlotterDataAdapter {
  constructor(protected _tableDefinitionFactory: OrdersTableDefinitionFactory) {
    super(_tableDefinitionFactory);
  }
}
